import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { user } from 'services/user';
import { socket } from 'api';
import { RackStateLine } from './rack-state-line/rack-state-line';
import { Content } from './rack-state.styled';

let working = false;
let timer;

export const RackState = (props) => {
  const { id, gooseMode = false, offline = true, timeOut = 3000 } = props;
  // console.log('🚀 ~ RackState ~ offline:', offline, timeOut, id, timer);
  const state = useSelector((state) => state.equipment[id]);

  useEffect(() => {
    const stopWorking = () => {
      working = false;
    };

    const setTimer = () => {
      if (offline) {
        working = false;
        if (timer) {
          clearInterval(timer);
        }
      } else {
        timer = setInterval(() => {
          // console.log('interval');
          if (!working) {
            working = true;
            socket.call('get_state_background', { target: id, user_id: user.getId() });
          }
        }, timeOut);
      }
    };

    setTimer();
    socket.on('get_state_background', stopWorking);

    return () => {
      socket.off('get_state_background', stopWorking);
      working = false;
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [offline]);

  if (!state || !Object.keys(state).length || (!gooseMode && !state.mode)) {
    return null;
  }

  /**
   * get lines
   * @returns
   */
  const getLines = () => {
    const out = [];
    if (state.controller) {
      out.push(<RackStateLine obj={state.controller} key="line1" />);
    }

    if (state.gateway) {
      out.push(<RackStateLine obj={state.gateway} key="line2" gate />);
    }
    return out;
  };

  const items = getLines();
  if (!items || !items.length) {
    return null;
  }

  return <Content>{items}</Content>;
};

// getTitle = (name) => {
//   const { t } = this.props;
//   return t(`sensors.${titles[name].title}`, name);
// };

// getInfo = (name) => {
//   const { t } = this.props;
//   return t(`sensors.${titles[name].info}`, name);
// };
